import React from 'react';
import { useMetaPixel } from '../hooks/useMetaPixel';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { IdentificationSection } from '../components/IdentificationSection';
import { SolutionSection } from '../components/SolutionSection';
import { ManualContents } from '../components/ManualContents';
import { SocialProof } from '../components/SocialProof';
import { OfferSection } from '../components/OfferSection';
import { SalesFooter } from '../components/SalesFooter';
export function SalesPage() {
  useMetaPixel();
  return <div className="min-h-screen bg-[#0A0A0A] text-[#D1D5DB] font-sans selection:bg-[#1A7A4A]/30" data-id="element-185">
      <UrgencyBar data-id="element-186" />
      <main data-id="element-187">
        <HeroSection data-id="element-188" />
        <PainSection data-id="element-189" />
        <IdentificationSection data-id="element-190" />
        <SolutionSection data-id="element-191" />
        <ManualContents data-id="element-192" />
        <SocialProof data-id="element-193" />
        <OfferSection data-id="element-194" />
      </main>
      <SalesFooter data-id="element-195" />
    </div>;
}